import { _orders } from "../constants/api";
import { toast } from 'react-toastify';

export const getAllOrders = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_orders}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    const responseJSON = await response.json();
    return responseJSON;

  } catch (error) {
    console.log('Error occurred in the get all orders API ==> ', error);
    toast.error('Failed to fetch orders.');
  }
};

export const updateOrderStatus = async (id, orderStatus) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_orders}/${id}/status`, {
      method: 'PUT', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: JSON.stringify({ orderStatus }),  
    });

    if (!response.ok) {
      throw new Error('Failed to update order status');
    }

    const responseJSON = await response.json();

    return responseJSON;

  } catch (error) {
    console.log('Error occurred in the update orders status API ==> ', error);
  }
};
